import React from "react";
import { BookUtils, NavigatorAction } from "../../../../../flux";
import { getRangeType, getType } from "./utils";
import PropTypes from "prop-types";

const ASSIGNMENT_META = [
  {
    // This indicates the tool that will be used to edit each reading
    tooling: "contents-selection"
  }
];

export default function withTocFunctions(ComponentWithTocFuncs) {
  class WithTocFunctions extends React.Component {
    tocEntries = this.props.book
      .getTOC()
      .filter(chapter => chapter.level === 1);
    lastDocument = BookUtils.getLastDocument(this.props.book.isbn);
    pageEnds = BookUtils.getChapterRanges(this.props.book.isbn).map(chapter =>
      chapter.pop()
    );

    back = () => {
      NavigatorAction.pop();
    };

    onCreateReadings = tocEntries => {
      this.createAssignmentIfNeeded()
        .then(() => this.createReadingItems(tocEntries))
        // Outer integration code catches api errors
        .then(() => this.back());
    };

    createAssignmentIfNeeded() {
      if (!this.props.hasAssignment) {
        return this.props.createOrUpdateAssignment();
      }
      return Promise.resolve();
    }

    createReadingItems = async tocEntries => {
      for (let i = 0; i < tocEntries.length; i++) {
        // These must be done in serial rather than parallel due to containing
        // assignments code only being able to process one save at a time
        const reading = await this.createReadingData(tocEntries[i]);
        await this.props.createReading(reading, ASSIGNMENT_META);
        // Outer integration code catches api errors
      }
    };

    async createReadingData(tocItem) {
      const indexInToc = this.tocEntries.indexOf(tocItem);
      const nextChapter = this.tocEntries[indexInToc + 1] || {cfi: BookUtils.nextDoc(this.lastDocument.cfi)};
      const [endCFI, _] = nextChapter.cfi.split("!");
      if (indexInToc !== -1) {
        return {
          start: tocItem.cfi,
          end: getType(this.props.book) === "pbk" ? endCFI : `${endCFI}!`,
          description: tocItem.title,
          exclusive: true,
          type: getType(this.props.book),
          range_type: getRangeType(this.props.book)
          // order: controlled externally
          // summary: intentionally omitted due to clunkiness
        };
      }
    }

    render() {
      return (
        <ComponentWithTocFuncs
          tocEntries={this.tocEntries}
          onCancel={this.back}
          onCreateReadings={this.onCreateReadings}
          saving={this.props.saving}
        />
      );
    }
  }

  WithTocFunctions.propTypes = {
    book: PropTypes.shape({ isbn: PropTypes.string.isRequired }),
    createOrUpdateAssignment: PropTypes.func.isRequired,
    createReading: PropTypes.func.isRequired,
    hasAssignment: PropTypes.bool.isRequired,
    saving: PropTypes.bool.isRequired,
  };

  return WithTocFunctions;
}
